export default "__VITE_ASSET__Bh5No8uX__"